import React from 'react';
import { Button } from 'react-bootstrap';
import './Button.scss';

//variant : 'primary' | 'secondary'

const GenericButton = (props) => {
  const {
    children,
    variant = 'primary',
    className: cssClass,
    ...restProps
  } = props;

  let className =
    variant === 'secondary'
      ? 'secondary-button'
      : variant === 'link'
      ? 'link-button'
      : '';

  if (props.disabled) {
    className += ' disabled-button';
  }
  if (cssClass) {
    className += ` ${cssClass}`;
  }
  return (
    <Button
      {...restProps}
      bsPrefix="generic-primary-button"
      className={className}
    >
      {children}
    </Button>
  );
};

export default GenericButton;
